/*
 *
 * OperationSummary
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 01-Jul-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { timezoneDateConverter } from 'Utility/dateMethods'
import { formatFiscalAmount } from 'Utility/numberMethods'
import PortalTextBlocked from 'Components/PortalTextBlocked'
import formattedMessage, { messages } from './languageModule'
import './OperationSummary.scss'

const OperationSummary = ({ summary, operationTerminalId, isLoading }) => {
  const intl = useIntl()
  const rawPaymentInstrumentInfo = summary?.paymentInstrumentInfo
  const paymentInstrumentInfo =
    typeof rawPaymentInstrumentInfo === 'string' ? rawPaymentInstrumentInfo.trim() : ''
  const hasPaymentInstrumentInfo = paymentInstrumentInfo && paymentInstrumentInfo.toUpperCase() !== 'NOT_DEFINED'

  const fields = {
    terminalId: operationTerminalId || '-',
    orderId: summary?.orderId || '-',
    operationId: summary?.operationId || '-',
    channel: summary?.channel || '-',
    operationType: (summary?.operationType && messages[summary?.operationType] && intl.formatMessage(messages[summary?.operationType])) || summary?.operationType || '-',
    operationResult: (summary?.operationResult && messages[summary?.operationResult] && intl.formatMessage(messages[summary?.operationResult])) || '-',
    operationTime: (summary?.operationTime && timezoneDateConverter(summary?.operationTime)) || '-',
    paymentMethod: messages?.[summary?.paymentMethod]
      ? intl.formatMessage(messages[summary.paymentMethod])
      : summary?.paymentMethod || '-',
    paymentInstrument:
      summary?.paymentCircuit && hasPaymentInstrumentInfo
        ? `${summary.paymentCircuit} ${paymentInstrumentInfo}`
        : '-',
    paymentEndToEndId: summary?.paymentEndToEndId || '-',
    operationAmount:
      (summary?.operationAmount &&
        summary?.operationCurrency &&
        formatFiscalAmount(summary?.operationAmount, summary?.operationCurrency)) ||
      '-'
  }

  return (
    <div className='text_field_section'>
      {fields &&
        Object.entries(fields).map(([field, value]) => (
          <PortalTextBlocked
            key={`operation-summary-field-${field}`}
            label={formattedMessage[field]}
            value={value || '-'}
            isLoading={isLoading}
            noPadding
          />
        ))}
    </div>
  )
}

OperationSummary.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
  summary: PropTypes.object,
  isLoading: PropTypes.bool,
  operationTerminalId: PropTypes.string
}

OperationSummary.defaultProps = {
  // Add here some default propTypes values
  summary: null,
  isLoading: false,
  operationTerminalId: null
}

export default OperationSummary
